import { FileViewerContextState } from "models/propTypes/fileViewerPropTypes";
import React from "react";

export const initialState: FileViewerContextState = {
  setUploadedFileDimensions: () => {},
  setContainerDimensions: () => {},
};

export const FileViewerContext = React.createContext<FileViewerContextState>(initialState);
